/* eslint-disable class-methods-use-this */
import {
	Module,
	VuexModule,
	Mutation,
	Action,
} from 'vuex-module-decorators';

@Module({
	namespaced: true,
	name: 'login',
})
export default class LoginStore extends VuexModule {
	public title = 'Welcome to Kasasa';

	public headline = 'Welcome to Kasasa';

	public modalText = '';

	public showModal = false;

	public showWell = true;

	public hasSubtitle = false;

	public subtitle = '';

	public hasError = false;

	public errorText = '';

	public hideConsumerLogin = false;

	public showLoader = false;

	@Mutation
	public setTitle(newTitle: string): void {
		this.title = newTitle;
	}

	@Mutation
	public setHeadline(newHeadline: string): void {
		this.headline = newHeadline;
	}

	@Mutation
	public setModalText(text: string): void {
		this.modalText = text;
	}

	@Mutation
	public toggleModal(): void {
		this.showModal = !this.showModal;
	}

	@Mutation
	public setWellState(newState: any): void {
		this.showWell = newState;
	}

	@Mutation
	public setHasSubtitleState(newState: any): void {
		this.hasSubtitle = newState;
	}

	@Mutation
	public setSubtitle(newSubtitle: string): void {
		this.subtitle = newSubtitle;
	}

	@Mutation
	public setHasErrorState(newState: any): void {
		this.hasError = newState;
	}

	@Mutation
	public setErrorText(text: string): void {
		this.errorText = text;
	}

	@Mutation
	public setConsumerLoginState(newState: any): void {
		this.hideConsumerLogin = newState;
	}

	@Mutation
	public setLoaderState(newState: any): void {
		this.showLoader = newState;
	}

	@Action({ rawError: true })
	public updateTitle(newTitle: string): void {
		this.setTitle(newTitle);
		window.document.title = newTitle;
	}

	@Action({ rawError: true })
	public showError(text: string): void {
		this.setErrorText(text);
		this.setHasErrorState(true);
	}

	@Action({ rawError: true })
	public clearError(): void {
		this.setErrorText('');
		this.setHasErrorState(false);
	}
}
